import React from "react";
// import Logo from "../../assets/Logo.svg";
// import Profile from "../../assets/ProfilePlaceholder.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { Capitalize } from "../../functions/text";
import AppCopy from "../../copy/AppCopy";
import { SideBarTabInterface, SideBarTabs } from "../../constants/tabs";
import { setActiveTab, setSidebarActive } from "../../reducers/pageReducer";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../hook/useLogout";
import Images from "images/Images";
import {
  IoCloseOutline,
  IoLogOutOutline,
  IoPerson,
} from "react-icons/io5";
import { DashboardLanguageButton } from "./DashboardLocalization";
import { translateDashboardText } from "i18n/dashboardLanguage";

function SideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigate1 = useNavigate();
  const logout = useLogout();
  const { unreadCount } = useSelector(
    (state: RootState) => state.notification
  );
  const { user } = useSelector((state: RootState) => state.user);
  const { activeTab, sidebarActive } = useSelector(
    (state: RootState) => state.page
  );

  const handleTabSelect = (tab: SideBarTabInterface) => {
    dispatch(setActiveTab(tab.name));
    dispatch(setSidebarActive(false));
    navigate(tab.path);
  };

  const handleLogout = () => {
    logout();
  };

  const handleOnLogoClick = () => {
    dispatch(setSidebarActive(false));
    navigate1("/");
  };

  const closeSidebar = () => dispatch(setSidebarActive(false));

  const { logoutText, titleText } = AppCopy.sideBar;
  return (
    <>
      {sidebarActive ? (
        <button
          type="button"
          className={ClassName.overlay}
          onClick={closeSidebar}
          aria-label="Close navigation"
        />
      ) : null}
      <aside
        className={`${ClassName.container} ${
          !sidebarActive && ClassName.hideSideBar
        }`}
        aria-label="Dashboard navigation"
      >
        <div className={ClassName.brandRow}>
          <button
            type="button"
            className={ClassName.logoButton}
            onClick={handleOnLogoClick}
            aria-label="Go to dashboard"
          >
            <img src={Images.logo} className={ClassName.logo} alt="BossCar" />
          </button>
          <button
            type="button"
            className={ClassName.closeButton}
            onClick={closeSidebar}
            aria-label="Close navigation"
          >
            <IoCloseOutline size={24} />
          </button>
        </div>

        <div className={ClassName.profileContainer}>
          <div className={ClassName.imageContainer}>
            <IoPerson size={22} />
          </div>
          <div className={ClassName.nameContainer}>
            <span className={ClassName.name}>{Capitalize(user?.name)}</span>
            <span className={ClassName.role}>{Capitalize(user?.role)}</span>
          </div>
        </div>

        <span className={ClassName.title}>{titleText}</span>
        <nav className={ClassName.nav}>
          {Object.values(SideBarTabs).map((tab: SideBarTabInterface) => {
            const hiddenForRole =
              user?.role !== "Admin" &&
              (tab.name === "Dashboard" ||
                tab.name === "Staff" ||
                tab.name === "App Update");

            if (hiddenForRole) return null;

            const active = activeTab === tab.name;
            return (
              <button
                type="button"
                key={tab.path}
                className={`${ClassName.tabContainer} ${
                  active
                    ? ClassName.activeTabContainer
                    : ClassName.inActiveTabContainer
                }`}
                onClick={() => handleTabSelect(tab)}
                aria-current={active ? "page" : undefined}
              >
                <div className={ClassName.tabIconContainer}>
                  <tab.icon size={17} />
                  {tab.name === "Notifications" && unreadCount > 0 ? (
                    <span className={ClassName.badge}>{unreadCount}</span>
                  ) : null}
                </div>
                <span className={ClassName.tabName}>
                  {translateDashboardText(tab.name)}
                </span>
              </button>
            );
          })}
        </nav>

        <div className={ClassName.filler}></div>

        <DashboardLanguageButton className={ClassName.languageButton} />

        <button type="button" className={ClassName.logout} onClick={handleLogout}>
          <IoLogOutOutline size={19} className="text-white" />
          <span className={ClassName.logoutText}>{logoutText}</span>
        </button>
      </aside>
    </>
  );
}

export default SideBar;

const ClassName = {
  container:
    "fixed left-0 top-0 z-50 flex h-screen w-[84vw] max-w-72 flex-col overflow-y-auto bg-slate-950 p-4 text-white shadow-2xl sm:p-5 xl:flex xl:w-72 xl:shadow-none",
  hideSideBar: "hidden xl:flex",
  overlay: "fixed inset-0 z-40 bg-black/40 xl:hidden",
  brandRow: "mb-4 flex h-10 items-center justify-between",
  logoButton: "rounded-lg p-1",
  logo: "w-24 object-contain",
  closeButton:
    "flex h-9 w-9 items-center justify-center rounded-lg text-slate-300 hover:bg-slate-800 hover:text-white xl:hidden",
  profileContainer:
    "flex w-full items-center border-y border-slate-800 px-2 py-4",
  imageContainer:
    "flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-slate-800 text-slate-200",
  nameContainer: "ml-3 flex min-w-0 flex-col",
  name: "truncate text-sm font-semibold",
  role: "mt-0.5 text-xs text-slate-400",
  title: "px-2 pb-2 pt-5 text-xs font-semibold uppercase tracking-wider text-slate-500",
  nav: "flex flex-col gap-1",
  tabContainer:
    "relative flex min-h-10 w-full flex-row items-center rounded-lg px-3 text-left text-sm transition-colors",
  activeTabContainer: "bg-primary text-white",
  inActiveTabContainer:
    "text-slate-300 hover:bg-slate-900 hover:text-white",
  tabIconContainer: "relative flex items-center justify-center w-5 h-5",
  tabIcon: "h-4 w-4 contain",
  tabName: "ml-3 text-xs font-medium",
  badge:
    "absolute -top-2 -right-2 min-w-4 h-4 px-1 rounded-full bg-primary text-white text-[10px] flex items-center justify-center",
  filler: "flex flex-1",
  languageButton:
    "mt-4 flex h-10 w-full items-center justify-center gap-2 rounded-lg border border-slate-700 bg-slate-950 px-4 text-xs font-medium text-slate-200 transition-colors hover:bg-slate-900 hover:text-white",
  logout:
    "mt-4 flex h-10 w-full flex-row items-center justify-center rounded-lg bg-slate-900 px-4 text-slate-200 transition-colors hover:bg-slate-800 hover:text-white",
  logoutText: "ml-2 text-xs font-medium",
};
